import { addDefaultHeader, removeDefaultHeader } from './http';

export function handleTokenChange(token) {
    if (token) {
        addDefaultHeader('Authorization', token);
    } else {
        removeDefaultHeader('Authorization');
    }
}



// WEBPACK FOOTER //
// ./src/utils/token.js